/** Shared day presets for top companies and top execs tables (numeric days). */
export const INSIDER_TIME_PERIOD_OPTIONS = [
  { value: 30, label: '30 Days' },
  { value: 90, label: '90 Days' },
] as const;

/** Trade type filter for Top Insider Companies & Top Execs (`all` = no trade_types filter). */
export const TRADE_TYPE_OPTIONS = [
  { value: 'all', label: 'All Types' },
  { value: 'p', label: 'Buy' },
  { value: 's', label: 'Sell' },
  // { value: 'p,m,c,o,x,e,h,k', label: 'Buy-Options' },
  // { value: 's,m,c,o,x,e,h,k', label: 'Sell-Options' },
] as const;

export const TRADE_SIZE_OPTIONS = [
  { value: 'all', label: 'All trade sizes' },
  { value: 'lt10k', label: '< $10K' },
  { value: 'gte10k', label: '+$10K' },
  { value: 'gte50k', label: '+$50K' },
  { value: 'gte100k', label: '+$100K' },
  { value: 'gte1m', label: '+$1M' },
] as const;

export type TradeSizeFilterValue = (typeof TRADE_SIZE_OPTIONS)[number]['value'];

export const INSIDER_ROLE_ALL = 'all' as const;

export type InsiderRoleFilterValue = typeof INSIDER_ROLE_ALL | 'is_director' | 'is_ten_percent_owner' | 'is_officer';

export const INSIDER_ROLE_OPTIONS: { value: InsiderRoleFilterValue; label: string }[] = [
  { value: INSIDER_ROLE_ALL, label: 'All roles' },
  { value: 'is_director', label: 'Director' },
  { value: 'is_ten_percent_owner', label: '10% owner' },
  { value: 'is_officer', label: 'Officer' },
];
